<script lang="ts">
	import type { Breadcrumb } from "@core/schema/Breadcrumb.js";

	const { breadcrumbs }: { breadcrumbs: Breadcrumb[] } = $props();
</script>

{#if breadcrumbs.length > 0}
	<div class="full-width mb-4 md:mb-8">
		<div class="text-xs/tight py-5 md:py-8 flex gap-2 overflow-auto pl-4 sm:pl-8 mt-1 flex-wrap" role="menubar">
			{#each breadcrumbs as { href, label }, index (index)}
				{#if index > 0}
					<span class="font-light text-cmcsecondary" role="separator">/</span>
				{/if}
				{#if href}
					<a {href} class="last:underline underline-offset-1 hover:text-cmcprimary" role="menuitem">
						{label}
					</a>
				{:else}
					<span role="menuitem">
						{label}
					</span>
				{/if}
			{/each}
		</div>
	</div>
{:else}
	<div class="h-12 md:h-16"></div>
{/if}
